export enum ServerData {
  ClientEligible = 'Yes',
  ClientNotEligible = 'No',
  ClientActive = 'Active',
  ClientInactive = 'Inactive',
  ClientNotApplicable = 'N/A',
  ClientRoleUser = 'User',
  ClientRoleAdmin = 'Admin',
  ServerRoleUser = 'ROLE_USER',
  ServerRoleAdmin = 'ROLE_ADMIN'
}
